export default "__VITE_ASSET__DWDNQLab__"